// components/ui/Button.js
import React from 'react';

export const Button = ({ 
  children, 
  className = "", 
  variant = "default", 
  ...props 
}) => {
  const baseStyles = "inline-flex items-center px-4 py-2 text-sm font-medium rounded transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variants = {
    default: "bg-green-600 text-white hover:bg-green-700 focus:ring-green-500",
    outline: "border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 focus:ring-gray-500",
    secondary: "bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-500",
  };

  return (
    <button
      className={`
        ${baseStyles}
        ${variants[variant] || variants.default}
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;